import { Component, Inject } from '@angular/core';
import { MatSidenavModule } from "@angular/material/sidenav";
import { Title } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import {
  L10N_CONFIG,
  L10N_LOCALE,
  L10nConfig,
  L10nLocale,
  L10nTranslatePipe,
  L10nTranslationService
} from 'angular-l10n';
import { AngularMaterial2Module } from "./app.module.material";
import { Data } from "./providers/data";
import { AuthService } from './shared/auth.service';
import { BreadcrumbComponent } from "./shared/breadcrumb/breadcrumb.component";
import { BreadcrumbService } from './shared/breadcrumb/breadcrumb.service';
import { LoggerService } from './shared/logger.service';
import { MenuComponent } from "./shared/menu.component";
import { Kernantwort } from './shared/response/kernantwort.model';
import { SessionService } from './shared/session.service';

const PATH_FILE = 'app/app.component.ts';
const GUID_REGEXP = '[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}';

export type LayoutDirection = 'ltr' | 'rtl';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone:true,
	imports: [
		AngularMaterial2Module,
		RouterModule,
		MatSidenavModule,
		BreadcrumbComponent,
		MenuComponent,
		L10nTranslatePipe
	]

})
export class AppComponent {
  dir: LayoutDirection;
  isDarkTheme: boolean = false;
  fehler: Kernantwort = null;
  breadcrumbPrefix: string = '';
  _isCollapsedContent: boolean = true;

  constructor(
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    public authService: AuthService,
	@Inject(L10N_LOCALE) public locale: L10nLocale,
	@Inject(L10N_CONFIG) private config: L10nConfig,
	public translation: L10nTranslationService,
	public sessService: SessionService,
    public title: Title,
    private data: Data,
    private _logger: LoggerService) {
      this.initLocalization();
      this.initBreadcrumbs();
      this.title.setTitle(this.translation.translate('project.title'));
      this.translateBreadcrumbs();
  }

  initLocalization() {
    // Initializes direction.
  	this.dir = "ltr";
  }

  initBreadcrumbs() {
    this.breadcrumbService.hideRoute('/home');
    this.breadcrumbService.hideRoute('/protected');
    this.breadcrumbService.hideRoute('/verwaltung');
  }

  getNameForUser(id: string) {
    return 'specific name for user with id';
  }

  translateBreadcrumbs() {
    this.breadcrumbService.addFriendlyNameForRoute('/home', this.translation.translate('home.typ'));

    this.breadcrumbService.addFriendlyNameForRoute('/verwaltung/benutzer', this.translation.translate('benutzer.verwaltung-typ'));
    this.breadcrumbService.addFriendlyNameForRoute('/verwaltung/gruppe', this.translation.translate('kerngruppe.verwaltung-typ'));
    this.breadcrumbService.addFriendlyNameForRoute('/verwaltung/recht', this.translation.translate('kernrecht.verwaltung-typ'));
    this.breadcrumbService.addFriendlyNameForRoute('/verwaltung/navigation', this.translation.translate('navigation.verwaltung-typ'));

    this.breadcrumbService.addFriendlyNameForRoute('/protected/mga', this.translation.translate('milchgeldabrechnung.liste'));
    this.breadcrumbService.addFriendlyNameForRoute('/protected/fla', this.translation.translate('fuhrlohnabrechnung.liste'));
    this.breadcrumbService.addFriendlyNameForRoute('/protected/jd', this.translation.translate('jahresdaten.liste'));
    this.breadcrumbService.addFriendlyNameForRoute('/protected/md', this.translation.translate('monatsdaten.liste'));
    this.breadcrumbService.addFriendlyNameForRoute('/protected/sp', this.translation.translate('sonderproben.liste'));
    this.breadcrumbService.addFriendlyNameForRoute('/protected/tmm', this.translation.translate('taeglicheanlieferungsmenge.liste'));
    this.breadcrumbService.addFriendlyNameForRoute('/protected/tpe', this.translation.translate('taeglichesprobenergebnis.liste'));
    this.breadcrumbService.addFriendlyNameForRoute('/protected/we', this.translation.translate('rechnung.liste'));
    this.breadcrumbService.addFriendlyNameForRoute('/protected/mpm', this.translation.translate('monatlicheplanmenge.wartung'));
    this.breadcrumbService.addFriendlyNameForRoute('/protected/ls', this.translation.translate('lieferschein.liste'));
    this.breadcrumbService.addFriendlyNameForRoute('/protected/newskategorie', this.translation.translate('kategorie.liste'));
    this.breadcrumbService.addFriendlyNameForRoute('/protected/dokumentekategorie', this.translation.translate('kategorie.liste'));
    this.breadcrumbService.addFriendlyNameForRoute('/protected/vertraegekategorie', this.translation.translate('kategorie.liste'));
    this.breadcrumbService.addFriendlyNameForRoute('/protected/lieferantenwechsel', this.translation.translate('lieferant.liste'));
    this.breadcrumbService.hideRouteRegex('/kontaktkategorie/[0-9]');
    this.breadcrumbService.addFriendlyNameForRoute('/protected/kontaktkategorie', this.translation.translate('kontakt.kontaktart'));
    this.breadcrumbService.addFriendlyNameForRoute('/protected/kontakt', this.translation.translate('kontakt.liste'));
    this.breadcrumbService.addFriendlyNameForRoute('/protected/apk', this.translation.translate('ansprechpartner.liste'));
    this.breadcrumbService.addFriendlyNameForRoute('/protected/fb', this.translation.translate('fragebogen.liste'));
    this.breadcrumbService.addFriendlyNameForRoute('/protected/frageantwort', this.translation.translate('fragebogen.liste'));
    this.breadcrumbService.addFriendlyNameForRoute('/protected/frageantwort-fb', this.translation.translate('fragebogen.liste'));
    this.breadcrumbService.addFriendlyNameForRoute('/protected/kf', this.translation.translate('kontaktformular.titel'));
  }

  // Sets a new locale & currency.
  selectLocale(language: string, country: string, currency: string): void {
    this.locale.language = language;
    this.locale.currency = currency;
  }

  // Sets a new locale & currency.
  selectLocaleAndDir($event: any): void {
    this.selectLocale($event.language, $event.country, $event.currency);
    this.dir = $event.direction;
  }

  // Sets a new locale & currency.
  toggleTheme($event: any): void {
    this.isDarkTheme = !this.isDarkTheme;
  }

  isAuth() {
    return this.authService.isAuthenticated();
  }

  isHome(): boolean {
    return this.router.url == '/home';
  }
}
